import { NO_LIMIT } from '@tt4b/ttam-enums';
import { i18n } from './../../../i18n';

export const AGE_OPTIONS = () => [
  {
    value: NO_LIMIT,
    name: i18n.t('adgroup_no_limit'),
    disableLeadAds: true,
    disableSelectedIndustry: true,
  },
  {
    value: '13,17',
    name: '13-17',
    disableLeadAds: true,
    disableSelectedIndustry: true,
  },
  {
    value: '18,24',
    name: '18-24',
  },
  {
    value: '25,34',
    name: '25-34',
  },
  {
    value: '35,44',
    name: '35-44',
  },
  {
    value: '45,54',
    name: '45-54',
  },
  {
    value: '55,100',
    name: '55+',
  },
];
